
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import TableOrderSet from "@common/src/components/scope/table-order-set/index.vue";
import t from "@common/src/i18n/t";
const setting = namespace("setting");

@Component({
  components: { StandardFlag, SwitchStatus, TableOrderSet }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.choose-payment-method"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class TestingItemList extends Vue {
  @setting.Action getPatternPaymentList;
  @setting.Action savePayMethod;
  @setting.Action updateStatusList;
  @setting.Action updateSortList;
  allRightSelect = false;
  switchState = true;
  showCreatedPay = false;
  searchForm: any = {
    payMethodName: "",
    payMethodCode: ""
  };
  searchFormRules: any = {
    payMethodName: [{ required: true, message: t("setting.name-cannot-empty"), trigger: "blur" }]
  };
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  cardTemplateList: any[] = [];
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow?) {
    return this.updateStatusList({
      status: status,
      payMethodCodeArray: selectedRow
        ? [selectedRow.payMethodCode]
        : this.mix_selectedRows.map(item => item.payMethodCode)
    })
      .then(() => {
        this.$message.success(
          status === 1 ? (t("setting.enable-successful") as string) : (t("setting.disable-success") as string)
        );
        this.loadListData();
      })
      .catch(e => {
        if (e.code === "speedbiz.system.pay-method-least-one-valid") {
          this.$message.error(t("setting.valid-method-payment"));
        }
      });
  }
  created() {
    this.init();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPatternPaymentList({
      payMethodName: "",
      status: "",
      includeDebitCard: "1"
    }).then(data => {
      this.cardTemplateList = data.data;
      return data;
    });
  }
  async init() {
    this.loadListData();
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.newPayMode();
      } else {
        console.log("error submit!!");
      }
    });
  }
  newPayMode() {
    const parameters = {
      payMethodName: this.searchForm.payMethodName,
      payMethodCode: ""
    };
    this.savePayMethod(parameters).then(() => {
      this.loadListData();
      this.$message.success(t("finance.new-payment-method-successful!"));
      this.showCreatedPay = false;
      const refPay = this.$refs.searchForm as any;
      refPay.resetFields();
    });
  }
  handleEdit(row) {
    this.$router.push(`/marketing/card-template-edit/${row.cardTemplateCode}`);
  }
  handleView(row) {
    this.$router.push(`/marketing/card-template-view/${row.cardTemplateCode}`);
  }
  sortArrList(arr) {
    this.updateSortList({
      payMethodCodeArray: arr.map(item => {
        return item.payMethodCode;
      })
    }).then(() => {
      this.$message.success(t("setting.operate-successfully"));
      this.loadListData();
    });
  }
  handleOrderChange(type, index) {
    if (
      ((type === "upOne" || type === "upTop") && index === 0) ||
      ((type === "downOne" || type === "downBottom") && index === this.cardTemplateList.length - 1)
    ) {
      return;
    }
    let tmp;
    if (type === "upOne") {
      tmp = this.cardTemplateList[index];
      this.cardTemplateList[index] = this.cardTemplateList[index - 1];
      this.cardTemplateList[index - 1] = tmp;
      this.sortArrList(this.cardTemplateList);
    } else if (type === "downOne") {
      tmp = this.cardTemplateList[index];
      this.cardTemplateList[index] = this.cardTemplateList[index + 1];
      this.cardTemplateList[index + 1] = tmp;
      this.sortArrList(this.cardTemplateList);
    } else if (type === "upTop") {
      tmp = this.cardTemplateList[index];
      let arr = this.cardTemplateList;
      arr.splice(index, 1);
      arr.unshift(tmp);
      this.sortArrList(arr);
    } else if (type === "downBottom") {
      tmp = this.cardTemplateList[index];
      let arr = this.cardTemplateList;
      arr.splice(index, 1);
      arr.push(tmp);
      this.sortArrList(arr);
    }
  }
  allSelect(all) {
    if (all.length === this.cardTemplateList.length) {
      this.allRightSelect = true;
    } else {
      this.allRightSelect = false;
    }
  }
  isAllSelect(all) {
    //   根据数据长度every判断是否为全选
    if (all.length === this.cardTemplateList.length) {
      this.allRightSelect = true;
    } else {
      this.allRightSelect = false;
    }
  }
  //----------------
}
